import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import withAttr from 'flarum/common/utils/withAttr';
import ItemList from 'flarum/common/utils/ItemList';
import Form from 'flarum/common/components/Form';
import FieldSet from 'flarum/common/components/FieldSet';
import { getPermanentSuspensionDate } from '../helpers/suspensionHelper';
export default class SuspendUserModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    let until = this.attrs.user.suspendedUntil();
    const reason = this.attrs.user.suspendReason();
    const message = this.attrs.user.suspendMessage();
    let status = null;
    if (new Date() > until) until = null;
    if (until) {
      if (until.getFullYear() === 9999) status = 'indefinitely';else status = 'limited';
    }
    this.status = Stream(status);
    this.reason = Stream(reason);
    this.message = Stream(message);
    this.daysRemaining = Stream(status === 'limited' && -dayjs().diff(until, 'days') + 1);
  }
  className() {
    return 'SuspendUserModal Modal--medium';
  }
  title() {
    return app.translator.trans('flarum-suspend.forum.suspend_user.title', {
      user: this.attrs.user
    });
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, null, this.formItems().toArray(), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.loading,
      type: "submit"
    }, app.translator.trans('flarum-suspend.forum.suspend_user.submit_button')))));
  }
  radioItems() {
    const items = new ItemList();
    items.add('not-suspended', m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "status",
      checked: !this.status(),
      value: "",
      onclick: withAttr('value', this.status)
    }), app.translator.trans('flarum-suspend.forum.suspend_user.not_suspended_label')), 100);
    items.add('indefinitely', m("label", {
      className: "checkbox"
    }, m("input", {
      type: "radio",
      name: "status",
      checked: this.status() === 'indefinitely',
      value: "indefinitely",
      onclick: withAttr('value', this.status)
    }), app.translator.trans('flarum-suspend.forum.suspend_user.indefinitely_label')), 90);
    items.add('time-suspension', m("label", {
      className: "checkbox SuspendUserModal-days"
    }, m("input", {
      type: "radio",
      name: "status",
      checked: this.status() === 'limited',
      value: "limited",
      onclick: e => {
        this.status(e.target.value);
        m.redraw.sync();
        this.$('.SuspendUserModal-days-input input').select();
        e.redraw = false;
      }
    }), app.translator.trans('flarum-suspend.forum.suspend_user.limited_time_label'), this.status() === 'limited' && m("div", {
      className: "SuspendUserModal-days-input"
    }, m("input", {
      type: "number",
      min: "0",
      value: this.daysRemaining(),
      oninput: withAttr('value', this.daysRemaining),
      className: "FormControl"
    }), app.translator.trans('flarum-suspend.forum.suspend_user.limited_time_days_text'))), 80);
    return items;
  }
  formItems() {
    const items = new ItemList();
    items.add('radioItems', m(FieldSet, {
      label: app.translator.trans('flarum-suspend.forum.suspend_user.status_heading')
    }, this.radioItems().toArray()), 100);
    items.add('reason', m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('flarum-suspend.forum.suspend_user.reason')), m("textarea", {
      className: "FormControl",
      bidi: this.reason,
      placeholder: app.translator.trans('flarum-suspend.forum.suspend_user.placeholder_optional'),
      rows: "4"
    })), 90);
    items.add('message', m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('flarum-suspend.forum.suspend_user.display_message')), m("textarea", {
      className: "FormControl",
      bidi: this.message,
      placeholder: app.translator.trans('flarum-suspend.forum.suspend_user.placeholder_optional'),
      rows: "4"
    })), 80);
    return items;
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    let suspendedUntil = null;
    switch (this.status()) {
      case 'indefinitely':
        suspendedUntil = getPermanentSuspensionDate();
        break;
      case 'limited':
        suspendedUntil = dayjs().add(this.daysRemaining(), 'days').toDate();
        break;
      default:
      // no default
    }
    this.attrs.user.save({
      suspendedUntil,
      suspendReason: this.reason(),
      suspendMessage: this.message()
    }).then(() => this.hide(), this.loaded.bind(this));
  }
}
flarum.reg.add('flarum-suspend', 'forum/components/SuspendUserModal', SuspendUserModal);